import React from 'react';
import _ from 'lodash';

import _masterSlideLoader from '../../utilities/masterSlideLoader';
import { AnchorList } from './AnchorList';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import dialogLoader from '../../utilities/dialogLoader';
import { CloseEditView } from '../CloseEditView';
import PartnerCompanyBranchService from '../../services/PartnerCompanyBranch';
import { propsToCompanyId } from '../../utilities/partnerCompanyConfirmUtil';

/**
 * 会社情報確認メニュー
 * @props {boolean}isSelectedBasicInfomation:基本情報を選択済みにするか？
 * @props {boolean}isCcusManagementInfo:CCUS連携情報を選択済みにするか？
 * @props {boolean}isCompanySaftyInfo:労務安全項目を選択済みにするか？
 * @props {boolean}isEditable:編集中かどうか？
 * @props {number}selectedPartnerCompanyId：選択中の会社ID
 */
export class PartnerNaviList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageName: '',
      propsState: Object.create(null),
      joiningFlag: SessionStorageService.isCommonPartnerCompany(),
      isPartnerCompanyBranchExist: SessionStorageService.getIsPartnerCompanyBranchExist(),
    };
    this.getFirstPartnerCompanyBranchParams = {
      block_flags: [false, true],
      offset: 0,
      limit: 1,
      is_limit: 1,
    };
  }

  setPartnerCompanyBranchExist = () => {
    const { selectedPartnerCompanyId } = this.props;

    PartnerCompanyBranchService.partnerCompanyBranchList(
      selectedPartnerCompanyId,
      this.getFirstPartnerCompanyBranchParams
    ).then(({ result, data }) => {
      if (result) {
        const branches = _.get(data, 'entities.partner_company_branches');
        const isPartnerCompanyBranchExist = !_.isEmpty(branches);
        SessionStorageService.setIsPartnerCompanyBranchExist(
          isPartnerCompanyBranchExist ? '1' : '0'
        );
        this.setState({ isPartnerCompanyBranchExist });
      }
    });
  };

  confirmMoveToPage = (pageName, propsState) => {
    const { isEditable } = this.props;

    if (isEditable) {
      this.setState({ pageName, propsState }, () => {
        dialogLoader.show(CloseEditView, {
          callback: {
            close: () => {
              this.stayThisPage();
              dialogLoader.close();
            },
            clear: () => {
              this.moveToPage();
              dialogLoader.close();
            },
          },
        });
      });
    } else {
      _masterSlideLoader.show(pageName, {
        state: propsState,
      });
    }
  };

  moveToPage = () => {
    const { pageName, propsState } = this.state;
    const { onConfirm } = this.props;

    if (pageName === 'PrimeCcusPreview' && onConfirm) {
      onConfirm();
    } else {
      _masterSlideLoader.show(pageName, {
        state: propsState,
      });
    }
  };

  stayThisPage = () => {
    this.setState({
      pageName: '',
      propsState: Object.create(null),
    });
  };

  componentDidMount() {
    this.setPartnerCompanyBranchExist();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedPartnerCompanyId !== this.props.selectedPartnerCompanyId
    ) {
      this.setPartnerCompanyBranchExist();
    }
  }

  render() {
    const { joiningFlag, isPartnerCompanyBranchExist } = this.state;
    const {
      isSelectedBasicInfomation,
      selectedPartnerCompanyId,
      isSelectedPartnerBranchInfomation,
      isSelectedPartnerCompanyBranchSafetyPreview,
      isCcusManagementInfo,
      isCompanySaftyInfo,
      expirationCompany,
    } = this.props;

    return (
      <React.Fragment>
        <ul className='contruction-navi-list PartnerNaviList'>
          <AnchorList
            label={data.menuTitle.basicInformation}
            isSelected={isSelectedBasicInfomation}
            onClick={() =>
              this.confirmMoveToPage('CompanyPreview', {
                id: this.props.selectedPartnerCompanyId,
              })
            }
          />
          {joiningFlag && (
            <AnchorList
              label={data.menuTitle.ccusManagementInfo}
              isSelected={isCcusManagementInfo}
              className='PartnerNaviList__children__text'
              onClick={() =>
                this.confirmMoveToPage('PrimeCcusPreview', {
                  id: this.props.selectedPartnerCompanyId,
                })
              }
            />
          )}
          {joiningFlag && (
            <AnchorList
              label={data.menuTitle.companySaftyInformation}
              isSelected={isCompanySaftyInfo}
              className='PartnerNaviList__children__text'
              onClick={() =>
                this.confirmMoveToPage('CompanySaftyPreview', {
                  id: this.props.selectedPartnerCompanyId,
                })
              }
              warningText={
                _.has(this.props, 'expirationCompany') &&
                _.some([
                  expirationCompany.has_expired_company_safety,
                  expirationCompany.has_about_to_expire_company_safety,
                ])
                  ? expirationCompany.has_expired_company_safety
                    ? '期限切れの情報があります。'
                    : '期限切れ間近の情報があります。'
                  : ''
              }
              warningIcon={
                _.has(this.props, 'expirationCompany') &&
                _.some([
                  expirationCompany.has_expired_company_safety,
                  expirationCompany.has_about_to_expire_company_safety,
                ]) && (
                  <WarningIcon
                    color={
                      expirationCompany.has_expired_company_safety
                        ? 'warning'
                        : 'caution'
                    }
                  />
                )
              }
            />
          )}
          {joiningFlag && (
            <AnchorList
              label={data.menuTitle.partnerCompanyBranchInformation}
              isSelected={isSelectedPartnerBranchInfomation}
              onClick={() =>
                this.confirmMoveToPage('PartnerCompanyBranchPreview', {
                  id: this.props.selectedPartnerCompanyId,
                })
              }
            />
          )}
          {joiningFlag && isPartnerCompanyBranchExist && (
            <AnchorList
              label={data.menuTitle.PartnerCompanyBranchSafetyPreview}
              isSelected={isSelectedPartnerCompanyBranchSafetyPreview}
              className='PartnerNaviList__children__text'
              onClick={() =>
                this.confirmMoveToPage('PartnerCompanyBranchSafetyPreview', {
                  id: this.props.selectedPartnerCompanyId,
                })
              }
              warningText={
                _.has(this.props, 'expirationCompany') &&
                _.some([
                  expirationCompany.has_expired_company_branch_safety,
                  expirationCompany.has_about_to_expire_company_branch_safety,
                ])
                  ? expirationCompany.has_expired_company_branch_safety
                    ? '期限切れの情報があります。'
                    : '期限切れ間近の情報があります。'
                  : ''
              }
              warningIcon={
                _.has(this.props, 'expirationCompany') &&
                _.some([
                  expirationCompany.has_expired_company_branch_safety,
                  expirationCompany.has_about_to_expire_company_branch_safety,
                ]) && (
                  <WarningIcon
                    color={
                      expirationCompany.has_expired_company_branch_safety
                        ? 'warning'
                        : 'caution'
                    }
                  />
                )
              }
            />
          )}
        </ul>
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  menuTitle: {
    basicInformation: '本社情報',
    ccusManagementInfo: 'CCUS連携情報',
    companySaftyInformation: '労務安全項目',
    partnerCompanyBranchInformation: '支店情報',
    PartnerCompanyBranchSafetyPreview: '支店労務安全項目',
  },
};

const WarningIcon = props => {
  const { color } = props;
  return (
    <div
      className={`PartnerNaviList__warning-icon PartnerNaviList__warning-icon--${color}`}
    >
      <i className='icon-warning_round' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/list/PartnerNaviList.jsx